import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleGreen = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 5.5,
		fill: "#44C1A8",
		stroke: "#278B77"
	})
});
export default SvgCircleGreen;
